module.exports = __webpack_public_path__ + "media/images/icons/benefits_workshops-b17e202800faa99f604d62905f61027e.svg";